import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getUploadList } from 'api/uploads';
import { useCurrentLabId } from 'utils/useCurrentLab';

export const studyUploadListRefetchIntervalMs = 60000;

export const getStudyUploadListQueryKey = (studyId: string, labId: string) => ['studyUploads', studyId, labId];

export const useStudyUploadList = ({
  studyId,
  enabled = true,
  refetchIntervalMs = studyUploadListRefetchIntervalMs,
}: {
  studyId: string;
  enabled?: boolean;
  refetchIntervalMs?: number;
}) => {
  const { labId } = useCurrentLabId();

  return useQuery({
    queryKey: getStudyUploadListQueryKey(studyId, labId),
    queryFn: () => getUploadList({ studyId, labId }),
    refetchInterval: refetchIntervalMs,
    enabled,
  });
};

export const useRefreshStudyUploadList = () => {
  const queryClient = useQueryClient();
  const { labId } = useCurrentLabId();

  return useCallback(
    (studyId: string) => queryClient.invalidateQueries({ queryKey: getStudyUploadListQueryKey(studyId, labId) }),
    [queryClient, labId]
  );
};
